<template>
  <view-page
      :button-access="componentAccess"
      :baseRoute='baseRoute'
      :entity='entity'
      :model-entity="modelEntity"
      :page-title="setPageTitle"
  >
    <template v-slot="{ model }">
      <commercial-product-extra-info-form
          v-if="model.id"
          readonly v-model="model"
          card-title="Extra Info"
      />
    </template>

    <template v-slot:extra-button="{ model }">
      <vs-button
          v-if="model"
          class="mt-2 ml-4"
          color="light"
          @click="openEnableAlert(model)"
      >
        {{ model.IsEnabled ? "Deactivate" : "Activate" }}
      </vs-button>
    </template>
  </view-page>
</template>

<script>

import CommercialProductExtraInfoForm from "@/views/pages/commercial-products/CommercialProductExtraInfoForm";
import ViewPage from "@/views/components/Views/ViewPage";
import NotificationMixin from '../../../components/mixins/NotificationMixin';
import EnablePublishMixin from '../../../components/mixins/EnablePublishMixin';

export default {
  name: "CommercialProductExtraInfo",
  components: {
    CommercialProductExtraInfoForm,
    ViewPage,
  },
  mixins: [NotificationMixin, EnablePublishMixin],
  data() {
    return {
      baseRoute:'commercial-products.extra-info',
      entity:'Commercial Product',
      modelEntity: this.$api.commercialProducts,
      componentAccess: {
        canEdit: {
          route: 'commercial-products.extra-info.edit',
          access: false,
        },
        canDelete: {
          route: 'commercial-products.delete',
          access: false,
        },
        canRestore: {
          route: 'commercial-products.restore',
          access: false,
        },
      }
    };
  },
  methods: {
    setPageTitle(params) {
      if (!params.CommercialProductName) {
        return '';
      }

      const name = params.CommercialProductName || '';
      return "Commercial Product: " + name;
    }
  }
};
</script>

<style scoped>

</style>
